import { useSelector } from 'react-redux'

import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'
import { isAdminOrOwnerSelector } from 'selectors/current_user'

import { getSectionCompletedCount } from '../utils'
import { useGuideSteps } from './use-guide-steps'

const useCompleted = (skip) => {
  const data = useGuideSteps({ skip })
  const queryResult = useGetUserQuery()
  const userGuideSetupTeamLater = queryResult?.data?.activation_data?.user_guide_setup_team_later
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector)

  if (skip) return false
  if (!data) return true

  const basicsSection = data.collection?.find(({ identifier }) => (identifier === 'calendly_basics'))
  const basicsStepCount = basicsSection?.steps?.length ?? 0
  const completeBasicsCount = getSectionCompletedCount(basicsSection)

  const setupTeamSection = data.collection?.find(({ identifier }) => (identifier === 'set_up_your_team'))
  const setupTeamStepCount = setupTeamSection?.steps?.length ?? 0
  const completeSetupTeamCount = getSectionCompletedCount(setupTeamSection)

  if (isAdminOrOwner && (completeBasicsCount === basicsStepCount)) {
    return setupTeamStepCount === completeSetupTeamCount || userGuideSetupTeamLater
  }

  return completeBasicsCount === basicsStepCount
}

export const useUserDismissed = (skipCompleted = false) => {
  const completed = useCompleted(skipCompleted)
  const queryResult = useGetUserQuery()
  const userDismissed = queryResult?.data?.activation_data?.user_dismissed_guide
  const legacyDismissed = queryResult?.data?.activation_data?.getting_started_dismissed
  const [update] = useUpdateUserActivationDataMutation()
  const toggle = (state) => update({ user_dismissed_guide: state, user_guide_closed: state })

  return [Boolean(userDismissed || completed || legacyDismissed), toggle]
}
